import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

export interface RelatedPage {
  link: string;
  anchor: string;
  text: string;
}

@Component({
  selector: 'app-related-pages',
  imports: [RouterLink],
  templateUrl: './related-pages.component.html',
  styleUrl: './related-pages.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelatedPagesComponent {
  pages = input.required<RelatedPage[]>();
}
